import { formatDatetime } from "@/utils";

export const DateTime = ({ value }) => {
    return formatDatetime(value);
}
